export enum DeliveryMethod {
  INSTANT = 'instant',
  STANDARD = 'standard',
}